<script>
  import CircleContent from './CircleContent.svelte';

  export let answers = 0;
</script>

<CircleContent value={answers} label="Answer(s)" />
